module.exports = __webpack_public_path__ + "img/icon-ecosystem-green.b197f8a4.svg";